import AppConfig from "util/AppConfig";
import { AGENT_WORKFLOW_FEATURE_FLAG } from "aiagent/Constants";
import SuggestionsOverviewPanel from "./components/SuggestionsOverviewPanel";
import SuggestionsDetailPanel from "./components/SuggestionsDetailPanel";
const suggestionsPluginExports = {
  "eventDefinitions.components.overviewPageSections": [
    {
      key: "edta-suggestions-overview",
      component: SuggestionsOverviewPanel
    }
  ],
  "eventDefinitions.components.detailPageSections": [
    {
      key: "edta-suggestions-detail",
      component: SuggestionsDetailPanel
    }
  ]
};
const pluginExports = AppConfig.isFeatureEnabled(AGENT_WORKFLOW_FEATURE_FLAG) ? suggestionsPluginExports : {};
export default pluginExports;
